import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
        .state('main.panel.new_device_status', {
            url: '/new_device_status',
            controllerAs: 'ctrl',
            controller: controller,
            template:  template
        })
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/new_devices_status/routes.js
 **/